import { Button, Select, Input, Popconfirm, Typography } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { fmt } from "./tenantPackageHelpers";

const { Text } = Typography;

interface Props {
  currentPackageId: string | undefined;
  packages: any[];
  packagesLoading: boolean;
  selectedPackage: string | undefined;
  onSelectPackage: (value: string | undefined) => void;
  reassignNote: string;
  onReassignNoteChange: (value: string) => void;
  onAssign: () => void;
  assignPending: boolean;
  onUnassign: () => void;
  unassignPending: boolean;
}

export const PackageAssignForm: React.FC<Props> = ({
  currentPackageId,
  packages,
  packagesLoading,
  selectedPackage,
  onSelectPackage,
  reassignNote,
  onReassignNoteChange,
  onAssign,
  assignPending,
  onUnassign,
  unassignPending,
}) => {
  return (
    <div className="bg-white p-4 rounded-xl border border-gray-200">
      <Text strong className="text-sm block mb-2">
        {currentPackageId ? "Change Plan" : "Assign Plan"}
      </Text>
      <div className="flex flex-col gap-2">
        <Select
          allowClear
          className="w-full"
          placeholder="Select a package"
          loading={packagesLoading}
          value={selectedPackage}
          onChange={onSelectPackage}
          options={packages
            .filter((p: any) => p.id !== currentPackageId)
            .map((p: any) => ({
              value: p.id,
              label: `${p.name} — ${fmt(Number(p.price))}`,
            }))}
        />
        <Input
          placeholder="Reason for change (e.g. upgraded for multi-store need)"
          value={reassignNote}
          onChange={(e) => onReassignNoteChange(e.target.value)}
          className="text-xs"
        />
        <div className="flex gap-2">
          <Button
            type="primary"
            disabled={!selectedPackage}
            loading={assignPending}
            onClick={onAssign}
          >
            {currentPackageId ? "Update" : "Assign"}
          </Button>
          {currentPackageId && (
            <Popconfirm
              title="Unassign current plan?"
              description="Keeps the tenant's current features but clears plan billing."
              onConfirm={onUnassign}
              okText="Yes"
              cancelText="No"
            >
              <Button
                danger
                icon={<DeleteOutlined />}
                loading={unassignPending}
              />
            </Popconfirm>
          )}
        </div>
      </div>
    </div>
  );
};
